import { ComponentProps } from "react";
import { cn } from "@repo/utils/cn";

export type MainProps = ComponentProps<"main">;

export function Main({ className, ...props }: MainProps) {
  return (
    <main
      {...props}
      className={cn("ui:relative ui:z-10 ui:bg-backgroundPrimary", className)}
    />
  );
}
